export const FETCH_STUDENT_REPORTS = 'FETCH_STUDENT_REPORTS';
export const CREATE_REPORT = 'CREATE_REPORT';
export const DELETE_REPORT = 'DELETE_REPORT';
export const FETCH_STUDENT_REPORTS_DATA = 'FETCH_STUDENT_REPORTS_DATA';
